package kz.dentalcrm.app.core.utils

sealed interface Result<out R> {
    class Success<out R>(val value: R) : Result<R>
    data class Error(val code: Int?, val message: String?) : Result<Nothing>
    class Failure(val throwable: Throwable) : Result<Nothing>
}

inline fun <T> Result<T>.stateHandle(
    onError: (code: Int, message: String) -> Unit = { _, _ -> },
    onFailure: (throwable: Throwable) -> Unit = { _ -> },
    onSuccess: (data: T) -> Unit = {}
) {
    when (this) {
        is Result.Success -> {
            onSuccess(this.value)
        }

        is Result.Error -> {
            onError(this.code ?: -1, this.message ?: "Undefined error")
        }

        is Result.Failure -> {
            onFailure(this.throwable)
        }
    }
}

inline fun <T, R> Result<T>.map(transform: (value: T) -> R): Result<R> =
    when (this) {
        is Result.Success -> Result.Success(transform(value))
        is Result.Failure -> Result.Failure(throwable)
        is Result.Error -> Result.Error(code, message)
    }